var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRolloutProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -249) translate(16 249)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M25.709 9.574v11.595h1.321v1.6c0 .317-.261.574-.583.574H5.583c-.322 0-.583-.257-.583-.574v-1.6h1.322V9.574c0-.317.263-.574.587-.574h18.212c.324 0 .588.257.588.574zM13.212 21.43c.265.533.55.8.855.8h3.422c.472 0 .855-.483.855-.8h-5.132z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066B3",
    d: "M6.752 0v.666H2.918c-.428 0-.78.38-.828.868l-.006.115-.001 3.311.873-.717c.142-.117.352-.097.47.045.11.135.097.331-.026.451l-.02.018-1.417 1.167c-.116.095-.28.1-.4.018l-.024-.018L.12 4.757C-.02 4.64-.04 4.43.076 4.288c.111-.135.306-.16.448-.062l.021.017.872.717V1.75c0-.916.603-1.667 1.371-1.744L2.918 0h3.834z",
    transform: "translate(11 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F60",
    d: "M10.253 0v.666H6.42c-.428 0-.78.38-.828.868l-.006.115V4.96l.872-.717c.142-.117.352-.097.47.045.11.135.098.331-.026.451l-.02.018-1.417 1.167c-.116.095-.28.1-.4.018l-.024-.018-1.417-1.167c-.143-.117-.163-.327-.046-.469.111-.135.307-.16.448-.062l.022.017.871.717V1.75c0-.916.603-1.667 1.371-1.744L6.42 0h3.834z",
    transform: "translate(11 12) rotate(180 6.877 3)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolloutProject);
export default __webpack_public_path__ + "static/media/rollout-project.af04adaa4fbe04a2952a7b0189f00f29.svg";
export { ForwardRef as ReactComponent };